import { BitmapText, Color, Container, FillGradient, Text, TextStyle } from "pixi.js";
import { isFireFox } from "./utils";

export const JACKPOT_UPGRADE_TITLE_FONT_SIZE = 100;
export const JACKPOT_UPGRADE_AMOUNT_FONT_SIZE = 110;
export const JACKPOT_UPGRADE_LINE_GAP = 16;
export const INTRO_BANNER_LINE_GAP = 20;
export const INTRO_BANNER_PART_GAP = 8;

export function createGoldGradientFill(): FillGradient {
    const fill = new FillGradient(0, 0, 0, 32 * 1 * 3);
    const colors = ["#fdea00", "#fbf8cb", "#fee500"].map((color) => Color.shared.setValue(color).toNumber());

    colors.forEach((number, index) => {
        fill.addColorStop(index / colors.length, number);
    });

    return fill;
}

export function createUpgradeTitleStyle(
    fontFamily: string,
    fontWeight: "normal" | "bold",
    fontSize: number
): TextStyle {
    return new TextStyle({
        fontFamily,
        fontWeight,
        fontSize,
        fill: isFireFox() ? "#FFF55B" : { fill: createGoldGradientFill() },
        stroke: {
            color: "#a51300",
            width: 3,
        },
        dropShadow: {
            blur: 5,
            color: "#000000",
            distance: 5,
        },
        letterSpacing: 2,
        align: "center",
    });
}

export function parseJackpotUpgradeDesc(translated: string): { jackpot: string; upgraded: string; amount: string } {
    const stripMarkers = (value: string) => value.replace(/\[\[|\]\]/g, "").trim();
    const lines = translated.split("\n").map((line) => stripMarkers(line)).filter(Boolean);

    return {
        jackpot: lines[0] ?? "",
        upgraded: lines[1] ?? "",
        amount: lines[2] ?? "",
    };
}

export function parseJackpotIntroDesc(
    translated: string
): {
    collect: string;
    upgrade: string;
    youhave: string;
    freespins: string;
} {
    const stripMarkers = (value: string) =>
        value.replace(/\[\[|\]\]/g, "").trim();

    const lines = translated
        .split("\n")
        .map((line) => stripMarkers(line))
        .filter(Boolean);

    // const freespinsLine = lines[2] ?? "";

    // let youhave = freespinsLine;
    // let freespins = "";

    // if (freespinsLine.includes(":freespinsnumber")) {
    //     const parts = freespinsLine.split(":freespinsnumber");
    //     youhave = parts[0]?.trim() ?? "";
    //     freespins = parts[1]?.trim() ?? "";
    // }

    return {
        collect: lines[0] ?? "",
        upgrade: lines[1] ?? "",
        youhave: lines[2] ?? "",
        freespins: lines[3] ?? "",
    };
}

export function layoutJackpotUpgradeText(
    jackpotTitle: Text,
    upgradedTitle: Text,
    jackpotAmount: BitmapText,
    gap: number = JACKPOT_UPGRADE_LINE_GAP
): void {
    const jackpotHeight = jackpotTitle.height;
    const upgradedHeight = upgradedTitle.height;
    const amountHeight = jackpotAmount.height;
    const totalHeight = jackpotHeight + gap + upgradedHeight + gap + amountHeight;

    let y = -totalHeight / 2 + jackpotHeight / 2;
    jackpotTitle.position.set(0, y);

    y += jackpotHeight / 2 + gap + upgradedHeight / 2;
    upgradedTitle.position.set(0, y);

    y += upgradedHeight / 2 + gap + amountHeight / 2;
    jackpotAmount.position.set(0, y);
}

export function layoutHorizontalParts(parts: Container[], gap: number, y: number): void {
    const widths = parts.map((part) => part.width);
    const totalWidth = widths.reduce((sum, width) => sum + width, 0) + gap * (parts.length - 1);

    let x = -totalWidth / 2;
    parts.forEach((part, index) => {
        part.position.set(x + widths[index] / 2, y);
        x += widths[index] + (index < parts.length - 1 ? gap : 0);
    });
}

export function layoutIntroBannerText(
    line1: Container,
    line2: Text,
    line3: Container,
    lineGap: number = INTRO_BANNER_LINE_GAP
): void {
    const line1Height = line1.height;
    const line2Height = line2.height;
    const line3Height = line3.height;
    const totalHeight = line1Height + lineGap + line2Height + lineGap + line3Height;

    let y = -totalHeight / 2 + line1Height / 2;
    line1.position.set(0, y);

    y += line1Height / 2 + lineGap + line2Height / 2;
    line2.position.set(0, y);

    y += line2Height / 2 + lineGap + line3Height / 2;
    line3.position.set(0, y);
}
